import { productConstants } from '@/constants'

export const addAttrSpecSheet = (product, projectInfo) => {
	let optionAttrProduct = { type: 'specSheet' }

	switch (product?.type) {
		case productConstants.PRODUCT_TYPE_REGULAR:
			if (product?.isPersonalized) {
				optionAttrProduct = {
					...optionAttrProduct,
					subType: 'reference',
					params: {
						productType: product?.type,
						productId: product?._id,
						projectId: projectInfo?.id,
						isPersonalized: product?.isPersonalized,
						projectName: projectInfo?.name,
						familyId: product?.familyId,
						subFamily: product?.subFamily,
						reference: product?.referenceCode
					}
				}
			} else {
				optionAttrProduct = {
					...optionAttrProduct,
					subType: 'model',
					params: {
						productType: product?.type,
						productId: product?._id,
						familyId: product?.familyId,
						subFamily: product?.subFamily,
						model: product?.model
					}
				}
			}
			return optionAttrProduct

		case productConstants.PRODUCT_TYPE_CREATION:
			return (optionAttrProduct = {
				type: 'creationSpecSheet',
				subType: product?.isPersonalized ? 'creation' : 'umbrella',
				params: {
					projectId: projectInfo?.id,
					catalogId: projectInfo?.catalogId,
					currency: projectInfo?.currency,
					product: {
						subFamily: product?.subFamily,
						isPersonalized: product?.isPersonalized,
						productType: product?.type,
						creationCode: product?.creationCode,
						familyId: product?.familyId,
						model: product?.model
					}
				}
			})

		default:
			return optionAttrProduct
	}
}

export const addAttrInstallation = (product, projectInfo, lang) => {
	let optionAttrProduct = { type: 'manual' }

	if (product?.type === productConstants.PRODUCT_TYPE_REGULAR) {
		return (optionAttrProduct = {
			...optionAttrProduct,
			subType: productConstants.PRODUCT_TYPE_REGULAR,
			params: {
				productType: product?.type,
				familyId: product?.familyId,
				subFamilyId: product?.subFamily?.id,
				applicationLocationId: product?.applicationLocation.id,
				model: product?.model
			}
		})
	} else {
		return (optionAttrProduct = {
			...optionAttrProduct,
			subType: 'manualCreation',
			params: {
				productType: product?.type,
				creationCode: product?.creationCode,
				projectId: projectInfo?.id,
				familyId: product?.familyId,
				creationNumber: product?.creationNumber,
				language: lang
			}
		})
	}
}

export const addAttrEnergyLabel = (product, projectInfo) => ({
	type: 'energyLabel',
	params: {
		model: product?.model || product?.compositions[0]?.articles[0]?.model || '',
		familyId: product?.familyId,
		projectId: projectInfo?.id,
		subFamilyId: product?.subFamily.id
	}
})

export const addAttrModel3d = (product, projectInfo) => ({
	type: '2D_3D',
	params: {
		familyId: product?.familyId,
		subFamilyId: product?.subFamily?.id,
		applicationLocationId: product?.applicationLocation.id,
		model: product?.model || product?.compositions[0]?.articles[0]?.model || '',
		projectId: projectInfo?.id
	}
})

export const addAttrProductHD = (product, subType, projectInfo) => ({
	type: 'imagesHD',
	subType,
	params: {
		familyId: product?.familyId,
		subFamilyId: product?.subFamily?.id,
		applicationLocationId: product?.applicationLocation.id,
		model: product?.model || product?.compositions[0]?.articles[0]?.model || '',
		projectId: projectInfo?.id
	}
})

export const addAttrPhotometry = (product, projectInfo) => ({
	type: 'photometry',
	params: {
		familyId: product?.familyId,
		subFamilyId: product?.subFamily?.id,
		applicationLocationId: product?.applicationLocation.id,
		model: product?.model || product?.compositions[0]?.articles[0]?.model || '',
		projectId: projectInfo?.id
	}
})
